import { DateTime } from "luxon"

import { getKPIRequest } from "@/api/getKPIRequest"
import type { KPIGroupRequest } from "@/types/kpiTypes"

import { getMonthDates } from "../util/getMonthDates"
import { getMonths } from "../util/getMonths"

import type {
  FeedstockDate,
  FeedstockKPI,
  FeedstockMonth,
  FeedstockTableConfig,
} from "../types/feedstockTypes"

export const getFeedstockData = async (config: FeedstockTableConfig): Promise<FeedstockKPI> => {
  const req: KPIGroupRequest = {
    startDate: config.startDate,
    endDate: config.endDate,
    kpis: [config.kpi],
  }

  const res = await getKPIRequest(req)
  const kpi = res[0]

  const values: FeedstockMonth[] = getMonths(config.startDate, config.endDate).map((month) => {
    const kpiVals = kpi.values?.filter((kv) => DateTime.fromISO(kv.date).month == month.month) || []
    const dates: FeedstockDate[] = getMonthDates(month, config.endDate).map((date) => {
      const values = kpiVals.filter((kv) => kv.date == date)
      const total = values.reduce((a, c) => ({ ...a, value: a.value + c.value }), {
        date,
        locationId: values.at(0)?.locationId || 0,
        type: "Actual",
        dimensionKey: 0,
        value: 0,
      })
      values.push(total)
      return {
        date,
        values,
      }
    })
    return {
      month: month.toFormat("LLL yy"),
      dates,
    }
  })

  return {
    id: kpi.id,
    name: kpi.name,
    unit: kpi.unit,
    rows: values,
  }
}
